<template>
  <div class="col-12 px-0">
    <div v-for="(highlight, index) in highlights"
          :key="index"
    >
        <HighlightsFields
          :removable="Object.keys(highlights).indexOf(index) + 1 > 3"

          :id="Object.keys(highlights).indexOf(index) + 1"
          v-model="highlights[index]"
          :highlight-fields="highlightFields"
          @input="update"
          class="my-4"
          @remove="remove(index)"
        />
      </div>

    <div class="border-bottom mb-4">
      <button @click="addHighlight" class="btn btn-outline-primary w-100 mb-4"><icon icon="add" /> Add Section</button>
    </div>
  </div>
</template>

<script>
import HighlightsFields from '../ArticlesFields'

export default {
  name: 'WeeklyRoundUpHighlightsStep',

  components: {
    HighlightsFields,
  },

  data () {
    return {
      highlights: this.draft.steps.highlights || {},
    }
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
    highlightFields: {
      required: true,
      type: Boolean,
    },
  },

  beforeMount () {
    if (Object.keys(this.highlights).length === 0) {
      this.addHighlight()
      this.addHighlight()
      this.addHighlight()
    }
  },

  methods: {
    addHighlight () {
      this.$set(this.highlights, Object.keys(this.highlights).length.toString(), {})
    },

    remove (index) {
      this.$delete(this.highlights, index)
      this.update()
    },

    update () {
      this.$emit(
          'update',
          {
            steps: {
              highlights: this.highlights
            },
          }
      )
    },
  },
}
</script>
